const ExperienceData = [
  {
    id: 1,
    jobtitle: "Embedded Software Engineer",
    companyname: "Renesas",
    worktype: "Intern",
    duration: "June 2023 - August 2023",
    location: "Ho Chi Minh, Viet Nam",
    responsibility: [
      // `Guided a team of 70 Instagram growth specialists and over 5 team leaders.`,
      // `Revised company marketing practices, switched strategies at least once a month, and applied updates to training programs.`,
      // `Developed new growth strategies to improve results for over 6 thousand customers and arranged weekly meetings with the company Directors.`,
      // `In 10 months improved retention rate by almost 15%.`,
      // `Resolved all client complaints by collaborating with over 3 other departments such as sales, customer support, and the onboarding team.`,
      // `Individual performance review and weekly meetings with the team.`,
    ],
  }
];

const EducationData = [
  {
    name: "Ho Chi Minh City University of Technology",
    status: "Computer Engineering",
    year: "2020 - Now",
  }
];

const CertificationData = [
  // {
  //   name: "HTML and CSS in depth",
  //   source: "Meta",
  //   date: "Issued Sept 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.coursera.org/account/accomplishments/certificate/9X4535T5LVXG",
  // },
  // {
  //   name: "Interactivity with JavaScript",
  //   source: "University of Michigan",
  //   date: "Issued Sept 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.coursera.org/account/accomplishments/certificate/SVHSCXX3C5SY",
  // },
  // {
  //   name: "React Basics",
  //   source: "Meta",
  //   date: "Issued Sept 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.coursera.org/account/accomplishments/certificate/47UVLTZJDQYT",
  // },
  // {
  //   name: "Front End Development Libraries",
  //   source: "freeCodeCamp",
  //   date: "Issued Sept 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://freecodecamp.org/certification/catherineisonline/front-end-development-libraries",
  // },
  // {
  //   name: "Introduction to Front-End Development",
  //   source: "Meta",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.coursera.org/account/accomplishments/certificate/9VXW6YH858J5",
  // },
  // {
  //   name: "Front-End Engineer Career Path",
  //   source: "Codecademy",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/5f85dd867b67b60014ac9ea3",
  // },
  // {
  //   name: "Programming with JavaScript",
  //   source: "Meta",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.coursera.org/account/accomplishments/certificate/ZFLYLLM6GEBQ",
  // },
  // {
  //   name: "Version Control",
  //   source: "Meta",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.coursera.org/account/accomplishments/certificate/YC4U5PG6HCML",
  // },
  // {
  //   name: "Learn React",
  //   source: "Codecademy",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/af00e5032d0a68cc84879983f5d8333b",
  // },
  // {
  //   name: "Learn Intermediate JavaScript",
  //   source: "Codecademy",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/512386fdc7f6c934f98b01e6afa8285a",
  // },
  // {
  //   name: "Learn Intermediate CSS",
  //   source: "Codecademy",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/b3dec49423da50603c25618aee635027",
  // },
  // {
  //   name: "Create a Professional Website with Velo by Wix Course",
  //   source: "Codecademy",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/9605a581bda107153c433f7889dbc268",
  // },
  // {
  //   name: "Code Foundations",
  //   source: "Codecademy",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/5b55e668646caa552f8e4d1d",
  // },
  // {
  //   name: "Jira Fundamentals Badge",
  //   source: "Atlassian",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://university.atlassian.com/student/award/MXrALckUagVqUKYJqdvioenM",
  // },
  // {
  //   name: "Trello Fundamentals Badge",
  //   source: "Atlassian",
  //   date: "Issued Aug 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://university.atlassian.com/student/award/Xz2rCXRVypxn91pD5PsbYrby",
  // },
  // {
  //   name: "EF SET English Certificate 73/100 C2 Proficient",
  //   source: "EF Standard English Test (EF SET)",
  //   date: "Issued Jul 2022 · No Expiration Date",
  //   creditUrl: "https://www.efset.org/cert/7dr3HT",
  // },
  // {
  //   name: "JavaScript Algorithms and Data Structures",
  //   source: "freeCodeCamp",
  //   date: "Issued Jul 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://freecodecamp.org/certification/catherineisonline/javascript-algorithms-and-data-structures",
  // },
  // {
  //   name: "The Complete JavaScript Course 2022: From Zero to Expert by Jonas Schmedtmann",
  //   source: "Udemy",
  //   date: "Issued Jul 2022 · No Expiration Date",
  //   creditUrl:
  //     "https://www.udemy.com/certificate/UC-0ce60e41-2077-40bc-8385-b15db83540e5/",
  // },
  // {
  //   name: "React + Redux",
  //   source: "Sololearn",
  //   date: "Issued Dec 2021 · No Expiration Date",
  //   creditUrl: "https://www.sololearn.com/Certificate/1097-19028975/pdf",
  // },
  // {
  //   name: "Responsive Web Design",
  //   source: "Sololearn",
  //   date: "Issued Dec 2021 · No Expiration Date",
  //   creditUrl: "https://www.sololearn.com/Certificate/1162-19028975/pdf",
  // },
  // {
  //   name: "The Web Developer Bootcamp",
  //   source: "Udemy",
  //   date: "Issued Dec 2021 · No Expiration Date",
  //   creditUrl:
  //     "https://www.udemy.com/certificate/UC-89fa3340-29cd-4ca5-ab45-18efdde98029/",
  // },
  // {
  //   name: "Intro to HTML and CSS",
  //   source: "Lambda School",
  //   date: "Issued Nov 2021 · No Expiration Date",
  //   creditUrl: "https://mycourse.app/JN71ZydHJctFJzx37",
  // },
  // {
  //   name: "Building Interactive JavaScript Websites Course",
  //   source: "Codecademy",
  //   date: "Issued Sep 2021 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/36ae898a1d1c8524815305b2d1d2ebab",
  // },
  // {
  //   name: "Learn Bootstrap Course",
  //   source: "Codecademy",
  //   date: "Issued Sep 2021 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/0595479d03627a8cb816b069000e4d06",
  // },
  // {
  //   name: "Learn Git Course",
  //   source: "Codecademy",
  //   date: "Issued Sep 2021 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/a8ab218d5950c29861635cc0bf12fd13",
  // },
  // {
  //   name: "Learn JavaScript Course",
  //   source: "Codecademy",
  //   date: "Issued Sep 2021 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/705dcb15de0da4dd9d9fc4f3274b430e",
  // },
  // {
  //   name: "Learn the Command Line Course",
  //   source: "Codecademy",
  //   date: "Issued Sep 2021 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/c87ba0541f8be78bc2f4ba1128233f6f",
  // },
  // {
  //   name: "Responsive Web Design",
  //   source: "freeCodeCamp",
  //   date: "Issued Sep 2021 · No Expiration Date",
  //   creditUrl:
  //     "https://www.freecodecamp.org/certification/catherineisonline/responsive-web-design",
  // },
  // {
  //   name: "Web Development Career Path",
  //   source: "freeCodeCamp",
  //   date: "Issued Sep 2021 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/5b32457b646caa5007c30975",
  // },
  // {
  //   name: "SQL course",
  //   source: "Sololearn",
  //   date: "Issued Oct 2020 · No Expiration Date",
  //   creditUrl: "https://www.sololearn.com/Certificate/1060-19028975/pdf/",
  // },
  // {
  //   name: "CSS Fundamentals course",
  //   source: "Sololearn",
  //   date: "Issued Sep 2020 · No Expiration Date",
  //   creditUrl: "https://www.sololearn.com/Certificate/1023-19028975/pdf/",
  // },
  // {
  //   name: "JavaScript course",
  //   source: "Sololearn",
  //   date: "Issued Sep 2020 · No Expiration Date",
  //   creditUrl: "https://www.sololearn.com/Certificate/1024-19028975/pdf/",
  // },
  // {
  //   name: "jQuery course",
  //   source: "Sololearn",
  //   date: "Issued Sep 2020 · No Expiration Date",
  //   creditUrl: "https://www.sololearn.com/Certificate/1082-19028975/pdf/",
  // },
  // {
  //   name: "HTML course",
  //   source: "Sololearn",
  //   date: "Issued Jul 2020 · No Expiration Date",
  //   creditUrl: "https://www.sololearn.com/Certificate/1014-19028975/pdf/",
  // },
  // {
  //   name: "Build a Website with HTML, CSS, and Github Pages",
  //   source: "Codecademy",
  //   date: "Issued Jun 2020 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/5cadfefe5f1de806e9704577",
  // },
  // {
  //   name: "Learn CSS",
  //   source: "Codecademy",
  //   date: "Issued May 2020 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/9a5bb1fc45b4281af1fffec93b0aaf05",
  // },
  // {
  //   name: "Learn HTML",
  //   source: "Codecademy",
  //   date: "Issued Mar 2020 · No Expiration Date",
  //   creditUrl:
  //     "https://www.codecademy.com/profiles/catherineisonline/certificates/9eb0741e5ebef1f9f58a53bfac67d3a7",
  // },
];

export { ExperienceData, EducationData, CertificationData };
